import React from 'react'
import PropTypes from 'prop-types'

import { Card, List } from 'semantic-ui-react'

import CardProperty from 'Components/CardProperty'
import Permissions from 'Components/Permissions'

import { getFormattedDateString } from 'Global/Helpers/timeHelpers'
import { getStatus } from 'Global/Helpers/rugHelpers'

const RugCardDetailedStatus = ({ rug }) => {
  const rugStatus = getStatus(rug).text

  return (
    <Permissions
      permissions={[
        'rug.field.advisor',
        'rug.field.belCustomer',
        'rug.field.belNr',
        'rug.field.belRgDate',
        'rug.field.belRgDate',
        'rug.field.rsvMenge',
        'rug.field.status',
      ]}
      render={() => (
        <Card.Content extra>
          <List>
            {rug.advisor && (
              <Permissions
                permissions="rug.field.advisor"
                render={() => (
                  <CardProperty icon="spy" popUpContent="Advisor">
                    {rug.advisor}
                  </CardProperty>
                )}
              />
            )}

            <Permissions
              permissions="rug.field.status"
              render={() => (
                <CardProperty icon="shopping basket" popUpContent="Status">
                  {rugStatus}
                </CardProperty>
              )}
            />

            {typeof rug.rsvMenge === 'number' && rug.rsvMenge > 0 && (
              <Permissions
                permissions="rug.field.rsvMenge"
                render={() => (
                  <CardProperty icon="external" popUpContent="Reserved Quantity">
                    Reserved Quantity: {rug.rsvMenge}
                  </CardProperty>
                )}
              />
            )}

            {rug.belCustomer && (
              <Permissions
                permissions="rug.field.belCustomer"
                render={() => (
                  <CardProperty icon="user" popUpContent="Customer (Customer Number)">
                    {`${rug.belCustomer} (${rug.belCustomerNb})`}
                  </CardProperty>
                )}
              />
            )}

            {rug.belNr > 0 && (
              <Permissions
                permissions="rug.field.belNr"
                render={() => (
                  <CardProperty icon="file text outline" popUpContent="Invoice Number">
                    {rug.belNr}
                  </CardProperty>
                )}
              />
            )}

            {rugStatus !== 'On Consignment' && rug.belCustomer && rug.belRgDate && (
              <Permissions
                permissions="rug.field.belRgDate"
                render={() => (
                  <CardProperty icon="calendar outline" popUpContent="Invoice Date">
                    {getFormattedDateString(rug.belRgDate)}
                  </CardProperty>
                )}
              />
            )}

            {rugStatus === 'On Consignment' && rug.belRgDate && (
              <Permissions
                permissions="rug.field.belRgDate"
                render={() => (
                  <CardProperty icon="calendar outline" popUpContent="Consignment Date">
                    {getFormattedDateString(rug.belRgDate)}
                  </CardProperty>
                )}
              />
            )}
          </List>
        </Card.Content>
      )}
    />
  )
}

RugCardDetailedStatus.propTypes = {
  rug: PropTypes.object.isRequired,
}

export default RugCardDetailedStatus
